module.exports = __webpack_public_path__ + "media/A21.880124b4.mp3";